import { FC } from "react";
import { Modal, Box, Typography, Button, Backdrop } from "@mui/material";
import { useWebViewDetection } from "~@/hooks/useWebViewDetection";

interface PlayerInactiveModalProps {
  open: boolean;
  onClose?: () => void;
}

const PlayerInactiveModal: FC<PlayerInactiveModalProps> = ({
  open,
  onClose,
}) => {
  const { isWebView } = useWebViewDetection();

  function redirectToApp() {
    const userAgent = navigator.userAgent.toLowerCase();

    let appUrl = `besau://besau.kz/referral`;
    let marketUrl = `https://play.google.com/store/apps/details?id=kz.besau.superapp`;
    let iosMarketUrl = "https://apps.apple.com/app/kz.besau.superapp";

    if (/android/.test(userAgent)) {
      window.location.href = appUrl;

      window.location.href = marketUrl;
    } else if (/ipad|iphone|ipod/.test(userAgent)) {
      window.location.href = appUrl;

      window.location.href = iosMarketUrl;
    } else {
      appUrl = `https://myapp.market/redirect`;
      window.location.href = appUrl;
    }
  }

  const handleGetAccess = () => {
    if (isWebView) {
      window.flutter_call_payment_subscription?.();
    } else {
      redirectToApp();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 400,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 3,
          outline: "none",
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.4,
            color: "text.primary",
            mb: 1,
          }}
        >
          Доступ ограничен
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 1.25,
            color: "#4D4D4D",
            mb: 1,
          }}
        >
          Получите доступ к статистике и аналитике за все время участия в лиге
          JUMP.
        </Typography>

        <Button
          fullWidth
          onClick={handleGetAccess}
          sx={{
            backgroundColor: "#E9033A",
            borderRadius: "12px",
            py: "10px",
            px: "16px",
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.5,
            color: "white",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#C53030",
            },
          }}
        >
          Оформить участие в JUMP
        </Button>
      </Box>
    </Modal>
  );
};

export default PlayerInactiveModal;
